export default __webpack_public_path__ + "static/media/Prime-Logo-Coloured-Vertical.4a235aa5.png";